require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/is-iterable.js
// module id = 792
// module chunks = 2 3 4 5 8 9 10 11 12 13 14 16 17 18 19 20 21 23 24 25 27 28